import AppActionsMenu from './AppActionsMenu.vue'

export default AppActionsMenu
